import { Link } from 'react-router-dom';

export default function ServicesCTA() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto text-center">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-light text-foreground-950 tracking-[0.06em] leading-[1.3]">
          デモンストレーションを
          <br />
          ご希望の方
        </h2>
        <p className="mt-5 text-sm md:text-base text-foreground-500 tracking-[0.08em] font-sans font-light">
          30日間無料トライアルをご用意しています
        </p>
        <div className="mt-8">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-800 text-accent-400 text-sm md:text-base tracking-[0.08em] font-sans font-medium hover:bg-primary-700 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            無料トライアルを申し込む
            <i className="ri-arrow-right-line text-lg" />
          </Link>
        </div>

        {/* Product Screenshot Strip */}
        <div className="mt-16 overflow-hidden border-t border-background-200 pt-10">
          <div className="w-full aspect-[21/9] rounded-lg overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20modern%20dashboard%20UI%20screenshot%20showing%20financial%20data%20analytics%20charts%20and%20graphs%20on%20a%20white%20background%2C%20minimalist%20design%2C%20Japanese%20language%20labels%2C%20line%20charts%20and%20bar%20charts%2C%20professional%20fintech%20interface%2C%20clean%20layout%20with%20cards&width=1400&height=600&seq=services-dashboard-screenshot&orientation=landscape"
              alt="製品ダッシュボード"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}